export const setPersons = (state, persons) => {
  state.persons = persons;
};
export const setCountPersons = (state, count) => {
  state.personsCount = count;
};
export const personToLead = (state, id) => {
  state.persons = state.persons.filter((person) => person.id !== id);
};
export const addPerson = (state, person) => {
  state.persons = [person, ...state.persons];
};
export const setBusiness = (state, business) => {
  state.business = business;
};
export const setCountBusiness = (state, count) => {
  state.businessCount = count;
};
export const setCompanies = (state, companies) => {
  state.companies = companies;
};
export const setCountCompanies = (state, count) => {
  state.companiesCount = count;
};
export const addCompany = (state, company) => {
  state.companies = [company, ...state.companies];
};
export const setLeads = (state, leads) => {
  state.leads = leads;
};
export const addLeads = (state, lead) => {
  state.leads = [lead, ...state.leads];
};
export const setCountLeads = (state, count) => {
  state.leadsCount = count;
};
export const removeLead = (state, id) => {
  let idNumber = Number(id);
  state.leads = state.leads.filter((lead) => lead.id !== idNumber);
};
export const setStatus = (state, status) => {
  state.status = status;
};
export const setCountStatus = (state, count) => {
  state.statusCount = count;
};
export const setNeeds = (state, needs) => {
  state.needs = needs;
};
export const setCountNeeds = (state, count) => {
  state.needsCount = count;
};
export const addNeed = (state, need) => {
  state.needs = [need, ...state.needs];
};
export const setInteractions = (state, interactions) => {
  state.interactions = interactions;
};
export const setFunnelStages = (state, funelStages) => {
  state.funnelStages = funelStages;
};
export const setCountFunnelStages = (state, count) => {
  state.funnelStagesCount = count;
};
export const addFunnelStages = (state, stage) => {
  state.funnelStages = [stage, ...state.funnelStages];
};
export const setVariables = (state, variables) => {
  state.variables = variables;
};
export const setCountVariables = (state, count) => {
  state.variablesCount = count;
};
export const setSales = (state, sales) => {
  state.sales = sales;
};
export const setSalesCount = (state, count) => {
  state.salesCount = count;
};
export const addVariable = (state, variable) => {
  state.variables = [variable, ...state.variables];
};
export const setBusinessByStage = (state, businessByStage) => {
  state.businessByStage = businessByStage;
};
export const setBusinessByStageCount = (state, count) => {
  state.businessByStageCount = count;
};
export const setVarTypes = (state, varTypes) => {
  state.varTypes = varTypes;
};
export const setVarTypesCount = (state, count) => {
  state.varTypesCount = count;
};
export const addVarTypes = (state, VarType) => {
  state.varTypes = [VarType, ...state.varTypes];
};
export const setTotalVentas = (state, total) => {
  state.total_ventas = total;
};
export const setAgenda = (state, agenda) => {
  state.agenda = agenda;
};
export const addEvent = (state, event) => {
  state.agenda = [event, ...state.agenda];
};
export const setCountAgenda = (state, count) => {
  state.agendaCount = count;
};
export const removeEvent = (state, id) => {
  let removedor = state.agenda.filter((event) => event.id != id);
  console.log("AJA MUTATION GO!", removedor);

  state.agenda = state.agenda.filter((event) => event.id != id);
};

export const setUsers = (state, users) => {
  state.users = users;
};

export const filterByUser = (state, user) => {
  state.business = state.business.filter(
    (business) => business.username === user
  );
};

export const updateCompany = (state, companyUpdate) => {
  let index = state.companies.findIndex(
    (company) => company.id === companyUpdate.id
  );
  // console.log('EL INDEX: ',index,'TO UPDATE: ', companyUpdate.id)
  state.companies[index] = companyUpdate;
};
export const updateEvent = (state, eventUpdate) => {
  let index = state.agenda.findIndex((event) => event.id === eventUpdate.id);
  console.log("INDEX: ", index);
  state.agenda[index] = eventUpdate;
};
export const updatePerson = (state, personUpdate) => {
  let index = state.persons.findIndex(
    (person) => person.id === personUpdate.id
  );
  console.log("INDEX: ", index);
  state.persons[index] = personUpdate;
};

export const setState = (state, { key, value }) => {
  state[key] = value;
};
export const removeState = (state, { key, keySearch, value }) => {
  state[key] = state[key].filter((item) => item[keySearch] !== value);
};
export const addEnty = (state, { key, value }) => {
  state[key] = [value, ...state[key]];
};
export const updateState = (state, { key, keySearch, value }) => {
  console.log(key, keySearch, value);
  let index = state[key].findIndex((item) => item.id === keySearch);
  console.log("INDEX: ", index);
  state[key][index] = value;
};
export const setstatusLeadCount = (state, count) => {
  state.statusLeadCount = count;
};
export const setEventDetail = (state, event) => {
  state.eventDetail = event;
};
export const setShowAnotations = (state, showAnotations) => {
  state.showAnotations = showAnotations;
};
export const setAnotationsCommiments = (state, anotations) => {
  state.infoAnotationsCommiments = anotations;
};
export const setEventSelected = (state, eventSelected) => {
  state.eventSelected = eventSelected;
};


